import React, { ReactElement } from 'react';
import {
  Checkbox, Loader, Select, Text,
} from 'idsk-react-components';
import { useParams } from 'react-router';
import { TerminListAdminFilter } from '../../../../../../model/TerminListAdminFilter';
import { SafeParameterSetter } from '../../../../../../model/SafeParameterSetter';
import SearchInput from '../searchInput/SearchInput';
import './sidePanel.scss';
import Secured from '../../../../../Secured';
import UserRoleEnum from '../../../../../../model/currentuser/UserRole';
import useAutorZmenyList from '../../../../../../hooks/useAutorZmenyList';

interface Props {
  filter: TerminListAdminFilter,
  onUpdateField?: SafeParameterSetter<TerminListAdminFilter>;
  filterCopy: TerminListAdminFilter;
  onUpdateFieldCopy: SafeParameterSetter<TerminListAdminFilter>;
  setFilter: (filter: TerminListAdminFilter) => void;
}

const SidePanel = ({
  filter, setFilter, filterCopy, onUpdateField, onUpdateFieldCopy,
}: Props): ReactElement => {
  const { tezaurusUuid } = useParams<{ tezaurusUuid: string }>();
  const {
    pouzivatelia,
    pouzivateliaStatus,
  } = useAutorZmenyList(tezaurusUuid);

  return (
    <div className="termin-list-admin-container">
      <SearchInput
        filterCopy={filterCopy}
        label="Hľadaný termín"
        filterSearchText={filterCopy?.hladanyTermin}
        fieldName="hladanyTermin"
        onUpdateFieldCopy={onUpdateFieldCopy}
        setFilter={setFilter}
        className="slovlex-idsk-side-panel-input-wrapper termin-container"
        maxLength={764}
      />
      <div className="slovlex-idsk-side-panel-input-wrapper">
        <Text className="blue-label">Stav publikácie</Text>
        <Checkbox
          className="idsk-checkboxes--small idsk-checkbox-no-margin"
          id="publikovany"
          checked={filter.publikovany === undefined ? false : filter.publikovany}
          onChange={e => onUpdateField('publikovany', e.target.checked ? true : undefined)}
        >Publikované
        </Checkbox>
        <Checkbox
          className="idsk-checkboxes--small idsk-checkbox-no-margin"
          id="nepublikovany"
          checked={filter.publikovany === undefined ? false : !filter.publikovany}
          onChange={e => onUpdateField('publikovany', e.target.checked ? false : undefined)}
        >Nepublikované
        </Checkbox>
      </div>
      <Secured allowForRoles={[UserRoleEnum.ADMINISTRATOR_TEZAURUS]}>
        <div className="slovlex-idsk-side-panel-input-wrapper">
          <Text className="blue-label" htmlFor="autorPoslednejZmeny">Autor poslednej zmeny</Text>
          <Loader loading={pouzivateliaStatus.loading}>
            <Select
              id="autorPoslednejZmeny"
              width="full"
              name="autorPoslednejZmeny"
              value={filter?.autorPoslednejZmeny?.uuid ? filter.autorPoslednejZmeny.uuid : ''}
              onChange={({ target }) => {
                const selectedPouzivatel = pouzivatelia.find(pouzivatel => pouzivatel.uuid === target.value);
                onUpdateField('autorPoslednejZmeny', target.value === '' ? undefined : selectedPouzivatel);
              }}
            >
              <option key="Vyberte" value="">Vyberte</option>
              {(pouzivatelia && pouzivatelia?.length > 0) ? (
                <>
                  {pouzivatelia
                    ?.map(pouzivatel => (
                      <option
                        key={pouzivatel.uuid}
                        value={pouzivatel.uuid}
                      >
                        {pouzivatel.nazov}
                      </option>
                    ))}
                </>
              ) : (
                <option key="emptyOption" value="emptyOption" disabled>
                  Nenašiel sa žiadny záznam.
                </option>
              )}
            </Select>
          </Loader>
        </div>
      </Secured>
    </div>
  );
};

export default SidePanel;
